import { RxByPrincipleReasonSet } from '@redteclab/api/clients/bully'
import { useEffect, useState, type VFC } from 'react'

import RxByPrincipleModal, {
  type RxByPrincipleModalProps,
} from 'views/components/organisms/RxByPrincipleModal'

export const RX_BY_PRINCIPLE_MODAL_CONTAINER_ID =
  'rx-by-principle-modal-container'

type RxByPrincipleModalContainerProps = {
  offerIdsWithAlreadySelectedReasons?: string[]
}

const RxByPrincipleModalContainer: VFC<RxByPrincipleModalContainerProps> = ({
  offerIdsWithAlreadySelectedReasons = [],
}) => {
  const [open, setOpen] = useState(false)
  const [productProps, setProductProps] =
    useState<
      Pick<
        RxByPrincipleModalProps,
        'onReasonSelect' | 'productName' | 'reasonSet'
      >
    >()

  useEffect(() => {
    const onBodyClick = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) {
        return
      }

      const link = event.target.closest<HTMLAnchorElement>(
        '[data-rx-by-principle-reason-set]'
      )

      if (!link) {
        return
      }

      const offerId = link.dataset.offerId as string
      const productName = link.dataset.productName as string
      const rxByPrincipleReasonSet = link.dataset
        .rxByPrincipleReasonSet as RxByPrincipleReasonSet

      if (offerIdsWithAlreadySelectedReasons.includes(offerId)) {
        return
      }

      event.preventDefault()

      setProductProps({
        onReasonSelect: reason => {
          const { href } = link

          const url = new URL(href)

          url.searchParams.append(`rxByPrincipleReason[${offerId}]`, reason)

          location.href = url.toString()
        },
        productName,
        reasonSet: rxByPrincipleReasonSet,
      })

      setOpen(true)
    }

    document.body.addEventListener('click', onBodyClick)

    return () => {
      document.body.removeEventListener('click', onBodyClick)
    }
  }, [offerIdsWithAlreadySelectedReasons])

  if (!productProps) {
    return null
  }

  return (
    <RxByPrincipleModal
      {...productProps}
      isClientSideControlled
      // @ts-expect-error -- need to check prop types
      onHideModal={() => {
        setOpen(false)
      }}
      open={open}
    />
  )
}

export default RxByPrincipleModalContainer
